export  const environment = {
  production: false,
  apiUrl: 'https://intxgpre.app/api/',//preprod
  apiUrlNewBack: 'https://intxgpre.app/api/',
  platformNameOrchGT: 'Mindx Live',
  mindxbkUrl: 'https://mindxlivepreback.app/api/',
  wssUrl: 'wss://mindxlivepreback.app/api/',

  turnstile: {
    siteKey: '0x4AAAAAAB1zhEDnjS4EEmo1', //preprod
  }
};

